import { useEffect, useState } from 'react';
import { db, auth, functions } from '../FirebaseAuthConfig.js';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

import Loader from './loader.js';

var non_staff_spouse = getCookie('non_staff_spouse') === 'true';

function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function Register() {
    const [userData, setUserData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [secondLoader, setSecondLoader] = useState(false);
    const [currentAuthUser, setCurrentAuthUser] = useState(null);

    const [displayName, setDisplayName] = useState('');
    const [email, setEmail] = useState('');
    const [firstEmailValue, setFirstEmailValue] = useState('');
    const [phone, setPhone] = useState('');
    const [firstPhoneValue, setFirstPhoneValue] = useState('');
    const [participationType, setParticipationType] = useState('select');
    const [battlePartner, setBattlePartner] = useState('');

    useEffect(() => {
        let unsubscribe = auth.onAuthStateChanged((currentUser) => {
            if (currentUser) {
                setCurrentAuthUser(currentUser);

                const checkUser = httpsCallable(functions, 'checkForUser');
                checkUser().then((response) => {
                    var resultData = response.data;

                    if (resultData.result === 'userExists - ISregistered') {
                        window.location.replace('/'); // TODO: Change back to '/' when challenge goes live
                    } else {
                        return;
                    }
                });
            } else {
                console.log('No logged in user found. Redirecting.');

                window.location.replace('/'); // TODO: Change back to '/' when challenge goes live
            }
        });
        return () => {
            unsubscribe();
        };
    }, []);

    useEffect(() => {
        if (!currentAuthUser) {
            return;
        }
        const getUserData = async () => {
            console.log('here');

            const docRef = doc(db, `userCollection/${currentAuthUser.uid}`);
            console.log('beginning wait');
            let getData = await getDoc(docRef);

            console.log('wait complete');
            setUserData(getData.data());
            console.log(getData.data());

            setDisplayName(getData.data().displayName);
            setEmail(getData.data().email);
            setPhone(getData.data().phone);
            setFirstEmailValue(getData.data().email);
            setFirstPhoneValue(getData.data().phone);

            setIsLoading(false);
        };

        getUserData();

        return () => {
            //
        };
    }, [currentAuthUser]);

    const submitData = async (e) => {
        e.preventDefault();

        setSecondLoader(true);

        var userData = {};

        const userRef = doc(db, `userCollection/${currentAuthUser.uid}`);
        await updateDoc(userRef, {
            displayName: displayName,
            email: email,
            phone: phone,
        });

        if (participationType === 'battlePartner') {
            userData = {
                userPath: `/userCollection/${currentAuthUser.uid}`,
                registered: true,
                team: '',
                nonStaffSpouse: non_staff_spouse,
                participationType: participationType,
                battlePartner: battlePartner,
            };
        } else {
            userData = {
                userPath: `/userCollection/${currentAuthUser.uid}`,
                registered: true,
                nonStaffSpouse: non_staff_spouse,
                participationType: participationType,
            };
        }

        const challengeRef = doc(db, `userCollection/${currentAuthUser.uid}/challengeData/everydayWarship`);
        await setDoc(challengeRef, userData);

        const registeredUserInChallengeColl = doc(db, `challengeCollection/everydayWarship/registeredUsers/${currentAuthUser.uid}`);
        await setDoc(registeredUserInChallengeColl, userData);

        window.location.replace('/'); // TODO: Change back to '/' when challenge goes live
    };

    if (isLoading) {
        return (
            <div className="w-screen h-screen bg-[#350A14] flex flex-col justify-center items-center">
                <Loader />
            </div>
        );
    }

    return (
        <div className="w-screen h-screen bg-[#350A14] flex flex-col justify-center items-center">
            <div className="w-full h-full flex flex-col justify-center items-center">
                <form className="max-w-[75%] grid grid-cols-1 md:grid-cols-2 gap-4" onSubmit={submitData}>
                    <div className="w-full flex flex-col justify-center items-start gap-2">
                        <h4 className="font-sans text-base font-normal text-white">First Name:</h4>
                        <input
                            className="w-full h-12 border-none rounded-2xl font-sans text-base sm:text-xl font-medium pl-4 text-[#202020] bg-white disabled:opacity-50 focus:outline focus:outline-[#FF671F] box-border"
                            type="text"
                            disabled
                            value={userData.firstName}
                        />
                    </div>
                    <div className="w-full flex flex-col justify-center items-start gap-2">
                        <h4 className="font-sans text-base font-normal text-white">Last Name:</h4>
                        <input
                            className="w-full h-12 border-none rounded-2xl font-sans text-base sm:text-xl font-medium pl-4 text-[#202020] bg-white disabled:opacity-50 focus:outline focus:outline-[#FF671F] box-border"
                            type="text"
                            disabled
                            value={userData.lastName}
                        />
                    </div>
                    <div className="w-full flex flex-col justify-center items-start gap-2">
                        <h4 className="font-sans text-base font-normal text-white">Display Name:</h4>
                        <input
                            className="w-full h-12 border-none rounded-2xl font-sans text-base sm:text-xl font-medium pl-4 text-[#202020] bg-white disabled:opacity-50 focus:outline focus:outline-[#FF671F] box-border"
                            type="text"
                            value={displayName}
                            required
                            onChange={(e) => setDisplayName(e.target.value)}
                        />
                    </div>
                    <div className="w-full flex flex-col justify-center items-start gap-2">
                        <h4 className="font-sans text-base font-normal text-white">Email Address:</h4>
                        {firstEmailValue === '' ? (
                            <input
                                className="w-full h-12 border-none rounded-2xl font-sans text-base sm:text-xl font-medium pl-4 text-[#202020] bg-white disabled:opacity-50 focus:outline focus:outline-[#FF671F] box-border"
                                type="text"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        ) : (
                            <input
                                className="w-full h-12 border-none rounded-2xl font-sans text-base sm:text-xl font-medium pl-4 text-[#202020] bg-white disabled:opacity-50 focus:outline focus:outline-[#FF671F] box-border"
                                type="text"
                                disabled
                                value={email}
                            />
                        )}
                    </div>
                    <div className="w-full flex flex-col justify-center items-start gap-2">
                        <h4 className="font-sans text-base font-normal text-white">Phone Number:</h4>
                        {firstPhoneValue === '' ? (
                            <input
                                className="w-full h-12 border-none rounded-2xl font-sans text-base sm:text-xl font-medium pl-4 text-[#202020] bg-white disabled:opacity-50 focus:outline focus:outline-[#FF671F] box-border"
                                type="text"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        ) : (
                            <input
                                className="w-full h-12 border-none rounded-2xl font-sans text-base sm:text-xl font-medium pl-4 text-[#202020] bg-white disabled:opacity-50 focus:outline focus:outline-[#FF671F] box-border"
                                type="text"
                                disabled
                                value={phone}
                            />
                        )}
                    </div>
                    <div className="w-full flex flex-col justify-center items-start gap-2">
                        <h4 className="font-sans text-base font-normal text-white">Category Type:</h4>
                        <select
                            className="w-full h-12 border-none rounded-2xl font-sans text-base sm:text-xl font-medium pl-4 text-[#202020] bg-white disabled:opacity-50 focus:outline focus:outline-[#FF671F] box-border"
                            required
                            onChange={(e) => setParticipationType(e.target.value)}
                        >
                            <option value="">I want to compete:</option>
                            <option value="battlePartner">With a Battle Partner</option>
                            <option value="individual">As an Individual (I don't want a Battle Partner)</option>
                        </select>
                    </div>
                    {participationType === 'battlePartner' && (
                        <div className="w-full flex flex-col justify-center items-start gap-2">
                            <h4 className="font-sans text-base font-normal text-white">My partner's Email OR Phone #:</h4>
                            <input
                                className="w-full h-12 border-none rounded-2xl font-sans text-base sm:text-xl font-medium pl-4 text-[#202020] bg-white disabled:opacity-50 focus:outline focus:outline-[#FF671F] box-border"
                                type="text"
                                value={battlePartner}
                                required
                                onChange={(e) => setBattlePartner(e.target.value)}
                            />
                        </div>
                    )}
                    <button
                        className="w-full md:w-[50%] md:mx-auto h-12 col-span-1 md:col-span-2 mt-4 px-4 border-none rounded-2xl bg-[#FF671F] font-sans text-md md:text-xl font-semibold tracking-[0.1rem] text-white text-center"
                        type="submit"
                    >
                        Save & Register
                    </button>
                </form>
                <button
                    className="max-w-[75%] mt-4 border-none bg-transparent flex flex-row justify-center items-center cursor-pointer"
                    onClick={() => {
                        window.open(
                            'https://staff.elevationchurch.org/support/tickets/new?category=Software&sub_category=Account%20Access&subject=Everyday%20WAR-Ship%20-%20Registration%20Support',
                            '_blank'
                        );
                    }}
                >
                    <h3 className="font-sans font-normal text-base text-white">
                        Is your information incorrect? <span className="font-semibold">Click here to submit a ticket.</span>
                    </h3>
                </button>
            </div>
            {secondLoader === true ? <Loader /> : null}
        </div>
    );
}

export default Register;
